document.addEventListener('DOMContentLoaded',() => {

    let woodType = ['oak']
    let notInCollect = ['stoney brooke']

    let getWoodStyles = document.querySelectorAll('.ghccMIcon')
    getWoodStyles.forEach(but =>{
        but.addEventListener('click',(event)=>{
            let clickedItemWoodType = event.target
            let woodType = clickedItemWoodType.parentNode.children[1].innerText
            if(woodType == 'Oak'){
                let getSwatchesCont = document.querySelector('#ghccFinishColumn').querySelectorAll('.ghccMStylesCont.oak')
                getSwatchesCont.forEach(cont => {
                    let allSwatchCont = cont.querySelectorAll('.ghccColorSamplerCont')
                    let contChildren = allSwatchCont[1].children
                    Array.from(contChildren).forEach(item => {
                        item.style.opacity = '0.4';
                        item.style.pointerEvents = 'none';
                        item.style.filter = 'grayscale(100%)';
                        item.style.cursor = 'not-allowed';
                        item.removeAttribute('onclick');
                    })
                })               
            }
            else if(woodType == 'Quartersawn Oak'){
                let getSwatchesCont = document.querySelector('#ghccFinishColumn').querySelectorAll('.ghccMStylesCont.quartersawn-oak')
                getSwatchesCont.forEach(cont => {
                    let allSwatchCont = cont.querySelectorAll('.ghccColorSamplerCont')
                    let contChildren = allSwatchCont[2].children
                    Array.from(contChildren).forEach(item => {
                        item.style.opacity = '0.4';
                        item.style.pointerEvents = 'none';
                        item.style.filter = 'grayscale(100%)';
                        item.style.cursor = 'not-allowed';
                        item.removeAttribute('onclick');
                    })
                })     
            }
        })
    })
})